<template>
    <div>
        <b-row>
            <b-col>
                <app-box titulo="Percentual a ser rateado">
                    {{percentualASerRateado 
                    | currency({
                        symbol: '%',
                        thousandsSeparator: '.',
                        fractionCount: 5,
                        fractionSeparator: ',',
                        symbolPosition: 'back',
                        symbolSpacing: false
                    })}}
                </app-box>
            </b-col>
            <b-col>
                <app-box
                    titulo="Percentual rateado"
                    :corBox="cor"
                    :corTexto="cor"
                    >{{ percentualRateado 
                    | currency({
                        symbol: '%',
                        thousandsSeparator: '.',
                        fractionCount: 5,
                        fractionSeparator: ',',
                        symbolPosition: 'back',
                        symbolSpacing: false
                    })}}
                </app-box>
            </b-col>
            <b-col>
                <app-box
                    titulo="Percentual disponível para ratear"
                    :corBox="cor"
                    :corTexto="cor"
                    >{{ percentualDisponivel 
                    | currency({
                        symbol: '%',
                        thousandsSeparator: '.',
                        fractionCount: 5,
                        fractionSeparator: ',',
                        symbolPosition: 'back',
                        symbolSpacing: false
                    })}}
                </app-box>
            </b-col>
        </b-row>
        <app-tabela
            idTabela="tblRateios"
            :itens="rateios"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="percentual" slot-scope="data">
                {{data.percentual | currency({
                                        symbol: '%',
                                        thousandsSeparator: '.',
                                        fractionCount: 2,
                                        fractionSeparator: ',',
                                        symbolPosition: 'back',
                                        symbolSpacing: false
                                    })}}%
            </template>
            <template slot="unidade" slot-scope="data"
                >({{ data.codUnidade }}) {{ data.nomeUnidade }}</template
            >
            <template slot="projeto" slot-scope="data"
                >({{ data.codProjeto }}) {{ data.nomeProjeto }}</template
            >
            <template slot="acao" slot-scope="data"
                >({{ data.codAcao }}) {{ data.nomeAcao }}</template
            >
            <template slot="botoes">
                <slot name="botoes"></slot>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-atualizar-dotacao-em-massa
                    :percentualTotal="percentualASerRateado"
                    :percentualDisponivel="percentualDisponivel"
                    :rateio="data"
                    @atualizarRateio="$emit('atualizarRateio', $event)"
                    @obterUnidades="$emit('obterUnidades')"
                    @obterProjetos="$emit('obterProjetos', $event)"
                    @obterAcoes="$emit('obterAcoes', $event)"
                    :unidades="unidades"
                    :projetos="projetos"
                    :acoes="acoes"
                ></btn-atualizar-dotacao-em-massa>
                <btn-excluir-dotacao
                    :rateio="data"
                    @excluirRateio="$emit('excluirRateio', data)"
                ></btn-excluir-dotacao>
                <slot name="acoes" v-bind="data"></slot>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import BtnExcluirDotacao from './BtnExcluirDotacao'
import BtnAtualizarDotacaoEmMassa from './BtnAtualizarDotacaoEmMassa'


export default {
    components: {
        BtnAtualizarDotacaoEmMassa,
        BtnExcluirDotacao
    },

    props: {
        rateios: {
            type: Array,
            default: () => {[]}
        },

        percentualASerRateado: {
            type: Number,
            default: () => 0
        },

        percentualRateado: {
            type: Number,
            default: () => 0
        },

        percentualDisponivel: {
            type: Number,
            default: () => 0
        },

        unidades: {
            type: Array
        }, 

        projetos: {
            type: Array
        }, 
        
        acoes: {
            type: Array
        }
    },
    
    computed: {
        cor() {
            return this.percentualRateado < this.percentualASerRateado ? 'danger' : 'primary'
        },
    },

    data() {
        return {
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'projeto',
                    label: 'Projeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'percentual',
                    label: 'percentual',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 0
        }
    }
}

</script>